// -----------------------
// Product Customizations
// -----------------------

// DOM Ready
function documentReady(fn) {
    if (document.readyState !== 'loading') {
        fn();
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

const cr = {
    lightboxDesktop: null,
    lightboxMobile: null,
    variantsSelected: function(type){
        let variantSelectors;
        if (type === 'radio'){
            variantSelectors = document.querySelector('variant-radios');
            const fieldsets = variantSelectors.querySelectorAll('fieldset');
            let values = [];
            fieldsets.forEach(fieldset => {
                const inputs = fieldset.querySelectorAll('input');
                inputs.forEach(input => {
                    if (input.checked){
                        values.push(input.getAttribute('value'));
                    }

                });
            });
            return values;
        }
        if (type === 'select'){
            variantSelectors = document.querySelectorAll('variant-selects select');
            let values = [];
            variantSelectors.forEach(select => {
                const selectedOption = select.options[select.selectedIndex];
                values.push(selectedOption.value);
            });
            return values;
        }

    },
    updateSelectedPrice: function(variantsSelected){
        const regularPrice = parseInt(cr.matchingVariant(variants, variantsSelected)?.price);
        const compareAtPrice = parseInt(cr.matchingVariant(variants, variantsSelected)?.compare_at_price);
        const discontinued = cr.matchingVariant(variants, variantsSelected)?.discontinued;
        const priceElement = document.querySelector('.pdp-price');
        const priceSaleElement = document.querySelector('.price__container');
        const salePriceElement = priceSaleElement.querySelector('.price-item--sale');
        let compareElement = priceSaleElement.querySelector('.price-item--regular');
        const currencyFormat = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD'
        })

        if (discontinued) {
            priceElement.style.setProperty('opacity', '0');
        } else {
            priceElement.style.setProperty('opacity', '1');

            priceSaleElement.classList.toggle('price__container--sale', compareAtPrice > regularPrice);
            compareElement.innerHTML = compareAtPrice > regularPrice ? currencyFormat.format(compareAtPrice / 100) : ''
            salePriceElement.innerHTML = currencyFormat.format(regularPrice / 100)
        }
    },
    variantsOnChange: function(type){
        let selectors;
        let selectors_label_color;
        if (type === 'radio'){
            selectors = document.querySelectorAll('.product-form__input input[type="radio"]');
            selectors_label_color = document.querySelectorAll('.product-form__input label[data-option-name="Color"]');
        }
        if (type === 'select'){
            selectors = document.querySelectorAll('.product-form__input select');
        }
        let option_first = selectors[0].getAttribute('name');

        if(Object.keys(product_images_by_option).length > 0) {
            cr.updateGalleryByVariant(cr.variantsSelected(type), option_first);
            cr.setCurrentColorNameLabel(cr.variantsSelected(type));
        }

        selectors.forEach(selector => {
            selector.addEventListener('change', event => {
                const currentVariant = cr.matchingVariant(variants, cr.variantsSelected(type));
                const currentVariantID = currentVariant?.id;
                // Update Product Photo
                document.querySelector('input.product-variant-id').value = currentVariantID;
                cr.updateSelectedPrice(cr.variantsSelected(type));
                cr.updateAvailabilityDisplay(cr.variantsSelected(type))
                cr.numberOfItemsInStock(cr.variantsSelected(type));

                cr.updateVariantAvailability(event);

                if(selector.getAttribute('name') === 'Color') {
                    cr.updateGalleryByVariant(cr.variantsSelected(type), option_first);
                    cr.setCurrentColorNameLabel(cr.variantsSelected(type));
                } else {
                    cr.updateGalleryByVariant(cr.variantsSelected(type), option_first);
                }
              
                cr.updateGiveawayBadge(currentVariant?.price);

                cr.updateVariantIdVarInURL(currentVariantID)
                cr.updateVariantIdInQTYBox(currentVariant)
            });

            cr.updateVariantAvailability();
            cr.numberOfItemsInStock(cr.variantsSelected(type));
        });

        selectors_label_color.forEach(selector => {
            selector.addEventListener('mouseover', event => {
                event.target.click()
            });
        })
    },


    updateGalleryByVariant: function(variantsSelected, optionFirst = 'Color') {
        if (Object.keys(product_images_by_option).length === 0) return;

        let isColor = false;
        let brand = 'other';
        let qty = variantsSelected[0] || 'other';
        if (optionFirst === 'Color') {
            isColor = true;
        } else if (optionFirst === 'Quantity' || optionFirst === 'Gallons') {
            brand = 'other';
            qty = variantsSelected[0] || 'other';
        } else if (optionFirst === 'Oil Brand' || optionFirst === 'Fluid Brand') {
            brand = variantsSelected[0] || 'other';
            qty = variantsSelected[1] || 'other';
        }

        // if (!isNaN(parseInt(variantsSelected[1]))) {
        //     brand = variantsSelected[0] || 'other';
        //     qty = variantsSelected[1] || 'other';
        // }
        //if (!brand || brand === '' || brand === 'Title' || brand === 'Size') brand = "Hot Shot's";
        if (!qty || qty === '' || qty === 'Title' || qty === 'Size') qty = 'other';

        const galleryDesktop = document.querySelector('.gallery-desktop');
        //const galleryMobile = document.querySelector('.gallery-mobile');
        const productPhotos = document.querySelector('.product-photos');
        const galleryColumn = document.querySelector('.pdp-image');
        // const pdpDetails = document.querySelector('.pdp-details');

        if (!galleryDesktop || !productPhotos) return;

        galleryDesktop.innerHTML = '';

        const oldSlider = document.querySelector('.js-slider-primary');
        if (oldSlider) {
            if ($(oldSlider).hasClass('slick-initialized')) {
                $(oldSlider).slick('unslick');
            }
            oldSlider.remove();
        }

        let images = [];

        if(!isColor) {
            if (optionFirst === 'Oil Brand' || optionFirst === 'Fluid Brand') {
                if (product_images_by_option[brand] && product_images_by_option[brand][qty]) {
                    images = Object.values(product_images_by_option[brand][qty]);
                }

                if (product_images_by_option[brand] && product_images_by_option[brand]['other']) {
                    images = images.concat(Object.values(product_images_by_option[brand]['other']));
                }
            } else if (optionFirst === 'Size') {
                images = Object.values(product_images_by_option['other']['other']);
            } else {
                images = Object.values(product_images_by_option['other'][qty]);
            }

            if (product_images_by_option['other'] && product_images_by_option['other']['other']) {
                images = images.concat(Object.values(product_images_by_option['other']['other']));
            }
        } else {
            images = Object.values(product_images_by_option[variantsSelected[0]]);
        }

        images = Array.from(new Set(images));

        if (images.length === 0) {
            productPhotos.style.height = '';
            return;
        }

        const productBadgesHTML = document.getElementById('ProductBadges')?.innerHTML || '';

        // --- Desktop layout ---
        const galleryMain = document.createElement('div');
        galleryMain.className = 'gallery-main relative';

        let firstImage = images[0][0];
        if(isColor) {
            firstImage = Object.values(images[0])[0][0];
        }

        const mainImageWrapper = document.createElement('div');
        mainImageWrapper.className = 'image-wrapper';

        mainImageWrapper.innerHTML = `
            ${productBadgesHTML}
            <a href="${firstImage.src}" class="zoom-wrapper"
               data-pswp-src="${firstImage.src}"
               data-pswp-width="1200"
               data-pswp-height="1200"
               data-pswp-gallery="product-gallery"
               aria-label="Zoom image">
                <img src="${firstImage.src}" alt="${firstImage.alt}" />
            </a>
        `;

        galleryMain.appendChild(mainImageWrapper);
        galleryDesktop.appendChild(galleryMain);

        const galleryGrid = document.createElement('div');
        galleryGrid.className = 'gallery-grid';
        if(isColor) {
            images = Object.values(images[0]);
        }

        images.slice(1).forEach(img => {
            const grid = document.createElement('div');
            grid.className = 'grid-image relative';
            grid.innerHTML = `
                <div class="image-wrapper">
                    <a href="${img[0].src}" class="zoom-wrapper"
                       aria-label="Zoom gallery"
                       data-pswp-src="${img[0].src}"
                       data-pswp-width="1200"
                       data-pswp-height="1200"
                       data-pswp-gallery="product-gallery">
                        <img src="${img[0].src}" alt="${img[0].alt}" />
                    </a>
                </div>
            `;
            galleryGrid.appendChild(grid);
        });

        galleryDesktop.appendChild(galleryGrid);

        // --- Mobile layout ---
        const newSlider = document.createElement('div');
        newSlider.className = 'js-slider-primary gallery-mobile';

        images.forEach((img, index) => {
            const slide = document.createElement('div');
            slide.className = 'grid-image relative';
            slide.innerHTML = `
                <div class="image-wrapper">
                    ${index === 0 ? productBadgesHTML : ''}
                    <img src="${img[0].src}" alt="${img[0].alt}" />
                    <a href="${img[0].src}" class="zoom-trigger"
                       aria-label="Zoom gallery"
                       data-pswp-src="${img[0].src}"
                       data-pswp-width="1200"
                       data-pswp-height="1200"
                       data-pswp-gallery="product-gallery">
                        <svg aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 16 16"><path d="M16 14.864 14.863 16l-4.24-4.241a6.406 6.406 0 0 1-4.048 1.392 6.61 6.61 0 0 1-4.65-1.925A6.493 6.493 0 0 1 .5 9.098 6.51 6.51 0 0 1 0 6.575a6.536 6.536 0 0 1 1.922-4.652A6.62 6.62 0 0 1 4.062.5 6.52 6.52 0 0 1 6.575 0 6.5 6.5 0 0 1 9.1.5c.8.332 1.51.806 2.129 1.423a6.454 6.454 0 0 1 1.436 2.13 6.54 6.54 0 0 1 .498 2.522c0 1.503-.468 2.853-1.4 4.048L16 14.864zM3.053 10.091c.973.972 2.147 1.461 3.522 1.461 1.378 0 2.551-.489 3.525-1.461.968-.967 1.45-2.138 1.45-3.514 0-1.37-.482-2.545-1.45-3.524-.981-.968-2.154-1.45-3.525-1.45-1.376 0-2.547.483-3.513 1.45-.973.973-1.46 2.146-1.46 3.523 0 1.375.483 2.548 1.45 3.515z"></path></svg>
                    </a>
                </div>
            `;
            newSlider.appendChild(slide);
        });

        productPhotos.appendChild(newSlider);

        requestAnimationFrame(() => {
            cr.initLightbox();
            cr.initMobileGallerySlider();
        });

        setTimeout(() => {
            const currentHeight = galleryColumn.offsetHeight;
            galleryColumn.style.minHeight = `${currentHeight}px`;
        }, 500);
    },

    matchingVariant: function(variants, variantsSelected) {
        return variants.find(variant => {
            return variant.options.every((option, index) => {
                return option === variantsSelected[index];
            });
        });
    },
    quantityChange: function(){
        const minButton = document.querySelector('.quantity-form .min');
        const plusButton = document.querySelector('.quantity-form .plus');
        const quantityInput = document.getElementById('Quantity');

        minButton.addEventListener('click', event => {
            event.preventDefault();
            let quantity = parseInt(quantityInput.value);
            if (quantity > 1) {
                quantity--;
                quantityInput.value = quantity;
            }
        });
        plusButton.addEventListener('click', event => {
            event.preventDefault();
            let quantity = parseInt(quantityInput.value);
            quantity++;
            quantityInput.value = quantity;
        });
    },
    numberOfItemsInStock: function(variantsSelected){
        const matchingVariant = cr.matchingVariant(variants, variantsSelected)
        let variantQuantity = document.getElementById("variant-quantity")
        if(variantQuantity) {
            const iconInventory = document.querySelector('.icon--inventory')
            const discontinued = cr.matchingVariant(variants, variantsSelected)?.discontinued

            iconInventory?.classList.remove('icon--inventory--in-stock')
            iconInventory?.classList.remove('icon--inventory--oos')
            iconInventory?.classList.remove('icon--inventory--low-on-stock')

            if (matchingVariant?.quantity < 1 || matchingVariant === undefined) {
                if (!discontinued) {
                    variantQuantity.textContent = "We are currently out of stock"
                } else {
                    variantQuantity.textContent = "This item is discontinued"
                }

                iconInventory?.classList.add('icon--inventory--oos')
            }

            if (matchingVariant?.available) {
                if (matchingVariant?.quantity > 0 && matchingVariant?.quantity < 10) {
                    variantQuantity.textContent = `Low on stock - ${matchingVariant?.quantity} available`

                    iconInventory?.classList.add('icon--inventory--low-on-stock')

                } else if (matchingVariant?.quantity >= 10) {
                    variantQuantity.textContent = `Item is in stock`

                    iconInventory?.classList.add('icon--inventory--in-stock')
                }
            }
        }
    },
    updateVariantAvailability: function(event) {
        var selectedOptions = {};
        const variantRadios = document.querySelectorAll('.product-form__input input[type="radio"]');
        variantRadios.forEach(radio => {
            radio.parentElement.classList.remove('variant-option--out-of-stock');

            if (radio.checked) {
                selectedOptions[radio.name] = radio.value;
            }
        });

        variantRadios.forEach(radio => {
            const variantValue = radio.value;
            let selectedOptionsCurrent = null;
            let matchingVariant = variants.find(variant => variant.options.includes(variantValue));

            if (selectedOptions?.Color) {
                selectedOptionsCurrent = selectedOptions?.Color;
                matchingVariant = variants.find(variant => variant.title.includes(`${selectedOptionsCurrent} / ${variantValue}`))
            }
            const hidden = matchingVariant?.hidden

            if(!hidden) {
                radio.parentElement.classList.remove('hidden');
            }

            if (matchingVariant && !matchingVariant?.available) {
                if (!selectedOptions?.Color || matchingVariant?.option1 === selectedOptions.Color) {
                    radio.parentElement.classList.add('variant-option--out-of-stock');
                    if(hidden) {
                        radio.parentElement.classList.add('hidden');
                    }
                }
            } else if (matchingVariant && matchingVariant?.hidden === true) {
                // radio.parentElement.classList.add('hidden');
            } else if (matchingVariant === undefined && radio.name === 'Size') {
                radio.parentElement.classList.add('variant-option--out-of-stock');
            }

            if(radio.name === 'Gallons' && (selectedOptions?.['Fluid Brand'] || selectedOptions?.['Oil Brand'])) {
                const selectedBrand = selectedOptions?.['Fluid Brand'] || selectedOptions?.['Oil Brand'];

                matchingVariant = variants.find(variant => variant.title.includes(`${selectedBrand} / ${variantValue}`))
                if(matchingVariant == undefined) {
                    radio?.parentElement.classList.add('hidden');
                    radio?.parentElement?.parentElement.querySelector('.option-item:not(.hidden) label')?.click();
                } else {
                    radio?.parentElement.classList.remove('hidden');
                }
            }
        });

        const variantSelects = document.querySelectorAll('.product-form__input select');
        variantSelects.forEach(select => {
            const options = select.querySelectorAll('option');
            options.forEach(option => {
                option.classList.remove('variant-option--out-of-stock');
                option.classList.remove('hidden');
            });

            if (!!select.value) {
                selectedOptions[select.name] = select.value;
            }

            // options.forEach(option => {
            //     const variantValue = option.value;
            //     const matchingVariant = variants.find(variant => variant.options.includes(variantValue));
            //     if (matchingVariant && !matchingVariant.available) {
            //         option.classList.add('variant-option--out-of-stock');
            //     }
            // });
        });

        // const selectedVariantTitle = Object.values(selectedOptions).join(" / ");
        // const matchingVariant = variants.find(variant => variant.title == selectedVariantTitle);
    },
    updateAvailabilityDisplay: function (variantsSelected) {
        const matchingVariant = cr.matchingVariant(variants, variantsSelected)
        const discontinued = cr.matchingVariant(variants, variantsSelected)?.discontinued
        const quantityElement = document.querySelector('.product__quantity')

        if (matchingVariant?.available) {
            document.querySelector(".js-go-cart-add-to-cart").removeAttribute("disabled")
            document.querySelector(".js-go-cart-add-to-cart").innerHTML = "ADD TO CART"
            Array.from(document.querySelector(".js-qty__wrapper").children).forEach(v => {
                v.removeAttribute("disabled");
            })
            document.querySelector(".js-qty__wrapper input").setAttribute("max", `${matchingVariant.inventory_quantity}`)
            let currentValue = document.querySelector(".js-qty__wrapper input").value
            if (currentValue > matchingVariant.inventory_quantity) {
                document.querySelector(".js-qty__wrapper input").value = matchingVariant.inventory_quantity
            }

            quantityElement.style.setProperty('opacity', '1');
        } else {
            document.querySelector(".js-go-cart-add-to-cart").setAttribute("disabled", "disabled")
            Array.from(document.querySelector(".js-qty__wrapper").children).forEach(v => {
                v.setAttribute("disabled", "")
            })
            document.querySelector(".js-qty__wrapper input").setAttribute("max", "1")

            if (!discontinued) {
                document.querySelector(".js-go-cart-add-to-cart").innerHTML = "SOLD OUT"
            } else {
                document.querySelector(".js-go-cart-add-to-cart").innerHTML = "DISCONTINUED"
                document.querySelector(".js-go-cart-add-to-cart").classList.add('discontinued')
            }

            quantityElement.style.setProperty('opacity', '0.5');
        }
    },
    setCurrentColorNameLabel: function(variantsSelected) {
        if(document.querySelector('.form__label[data-name="Color"]')?.length > 0) {
            document.querySelector('.form__label[data-name="Color"]').innerHTML = variantsSelected[0];
        }
    },
    updateGiveawayBadge: function(price) {
        const giveaway_multiplier = window?.giveaway_multiplier || 0;
        if(giveaway_multiplier > 0) {
            let entries = '0 entries';
            if(price !== undefined) {
                entries = Math.round((price / 100) * giveaway_multiplier) + ' entries';
            }

            document.querySelector('.product-giveaway-entry span:first-child').textContent = entries;
        }
    },
    initLightbox: function() {
        this.lightboxDesktop = new PhotoSwipeLightbox({
            gallery: '.gallery-desktop',
            children: 'a',
            pswpModule: PhotoSwipe,
            bgOpacity: 1,
            hideAnimationDuration: 0,
            showAnimationDuration: 0
        });
        this.lightboxDesktop.init();

        this.lightboxMobile = new PhotoSwipeLightbox({
            gallery: '.gallery-mobile',
            children: '.slick-slide:not(.slick-cloned) a',
            pswpModule: PhotoSwipe,
            bgOpacity: 1,
            hideAnimationDuration: 0,
            showAnimationDuration: 0
        });
        this.lightboxMobile.init();
    },
    initMobileGallerySlider: function() {
        const mobileSlider = $('.js-slider-primary');

        if (mobileSlider.length && mobileSlider.children().length > 0) {
            if (mobileSlider.hasClass('slick-initialized')) {
                mobileSlider.slick('unslick');
            }

            mobileSlider.slick({
                dots: false,
                arrows: false,
                centerMode: true,
                centerPadding: '20px',
                slidesToShow: 1,
            });
        }
    },
    updateVariantIdVarInURL: function(id) {
        if(id === undefined) return;

        const url = new URL(window.location);
        url.searchParams.set('variant', id);
        window.history.replaceState({}, '', url);
    },
    updateVariantIdInQTYBox: function(variantsSelected) {
        if(variantsSelected === undefined) return;

        const maxValue = (variantsSelected?.quantity) < 0 ? 1 : variantsSelected?.quantity || 1;
        const qtyWrapper = document.querySelector('.js-qty__wrapper');
        const form = document.getElementById(qtyWrapper.getAttribute('form'));
        qtyWrapper.dataset.productId = variantsSelected?.id;
        form.querySelector('.js-qty__num').setAttribute('max', `${maxValue}`);
    }
}

// Page is Ready
documentReady(function() {
    // Variant Radios
    if ( document.querySelector('variant-radios') !== null ){
        // Detect changes to radio buttons
        cr.variantsOnChange('radio');
    }

    // Variant Selects
    if ( document.querySelector('variant-selects') !== null ){
        // Detect changes to select elements
        cr.variantsOnChange('select');
    }

    // Quantity Change
    cr.quantityChange();

    cr.initLightbox();
    cr.initMobileGallerySlider();
});